// routes/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utility/auth";
import { isUser } from "../utility/auth";
const UserRoute = ({ element: Element }) => {
  return isAuthenticated() && isUser() ? <Element /> : <Navigate to="/"  replace />;
};

export default UserRoute;
